import { nanoid } from 'nanoid';
import { CommandId, EdgeId, NodeId } from '../../../types';

export interface IdFactory {
  nodeId(): NodeId;
  edgeId(): EdgeId;
  commandId(): CommandId;
}

export const defaultIdFactory: IdFactory = {
  nodeId: () => nanoid(10),
  edgeId: () => nanoid(10),
  commandId: () => nanoid(10),
};
